<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">New Credit Note</h4>
                <p class="text-subtitle-1">Credit Note Creation Form</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn depressed block @click="exchangeRateIndexShown = true">
                    <v-icon left>mdi-chart-areaspline-variant</v-icon>
                    currency exchange
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <CreditNoteForm
                    v-model="data"
                    ref="form"
                    @submit="handleSubmit"
                    :exchange-rate-index-shown.sync="exchangeRateIndexShown"
                    />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn color="primary" block :loading="loading"  @click="handleSave">
                    <v-icon left>mdi-content-save</v-icon>
                    save
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn depressed block @click="handleDiscard">
                    cancel
                </v-btn>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"></PAlert>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import PAlert from './../../components/common/PAlert.vue'
import CreditNoteForm from '@/components/purchase/CreditNoteForm' 
import { mapActions, mapGetters } from 'vuex'
import { v4 as uuid } from 'uuid';

export default {
    name: "CraditNoteCreateView",
    components: {
        CreditNoteForm,
        PAlert,
    },
    data() {
        return {
            loading: false,
            data: null,
            alert: {
                title: "Alert",
                content: "Are you sure",
                value:  false,
                callback: null
            },
            perm: permissions,
            idempotentKey: null,
            exchangeRateIndexShown: false
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            create: "purchase/creditNote/create",
            snackbar: "ui/snackbar/show"
        }), 
        handleSave() {
            this.alert = {...this.alert , value: true, content: "Are you sure you want to save", callback: this.handleSubmit}
        },
        handleNewLine() {
            this.$refs.form.addLine()
        },
        handleList() {
            this.$router.push({ name: "CreditNoteList"})
        },
        handleSubmit() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            this.create({...this.data, idempotentKey: this.idempotentKey}).then(response => {
                this.$router.push({ name: "CreditNoteDisplay", params: { id: response.data.id } })
                this.snackbar({text: "Credit Note create succesfuly", color: "success"})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({text: message, color: "error"})
            }).finally(() => {
                this.loading = false
            })
        },
        handleDiscard() {
            this.alert = {...this.alert,content: "Are You Sure You Want To Discard", value: true, callback: this.discard }
        },
        discard() {
            this.$router.back();
        },
    },
    mounted() {
        this.$refs.form.addLine();
    },
    created() {
        this.idempotentKey = uuid();
    }
}
</script>

<style>

</style>